export default Object.freeze({
  black: '#373C46',
  'black-light': '#999999',
  'black-darker': '#333333',
  'black-secondary': '#9F9F9F',

  white: '#FFFFFF',
  whiteish: '#F8F8F8',
  'white-opacity-1': 'rgba(248,248,248,0.85)',
  'white-opacity-2': 'rgba(255,255,255, 0.9)',

  gray: '#EAEAEA',
  'gray-light': '#F8F8F8',
  'gray-medium': '#E9E8E9',
  'gray-dark': '#E0E0E0',
  'gray-secondary': '#E1E1E1',
  'gray-label': '#736A65',

  'gray-opacity-1': 'rgba(0,0,0,0.35)',

  'gray-faded': '#9d9591',
  'gray-neutral': '#a18265',

  gold: '#A18265',
  'gold-dark': '#382A21',
  'gold-neutral': '#736A65',
  'gold-light': '#9D9591',
  'gold-border': '#816850',
  'gold-opacity': 'rgba(161,130,101, 0.75)',

  marine: '#56D1BF',
  aqua: '#D4F3EE',

  'light-blue': '#F3F9FB',

  'red-fade': '#FD5656',
  yellow: '#f5a623',
  green: '#56d1bf',
  'warm-green': '#2cc663',
});
